// 既に教習生がいる状態で、第1段階の学科枠を後追いで新規登録すると、条件によっては受講生の受講履歴が
// 歯抜けになってしまいシステムでデータの整合性を保てない。そのために補正用の受講履歴を作っている。
// このJSは補正用受講履歴作るけどいいですか？と確認するダイアログを制御する。
export default () => {
  const createLessonSlotBtn = document.getElementById('create-lesson-slot-btn');
  if (!createLessonSlotBtn) return;

  createLessonSlotBtn.addEventListener('click', (e) => {
    const category = document.getElementById('lesson_slot_category').value;
    const stage = document.getElementById('lesson_slot_stage').value;
    const course = document.getElementById('lesson_slot_course_number').value;
    const kind = document.getElementById('lesson_slot_kind').value;
    // 補正用受講履歴を作るべき教習生がいるかどうか
    const { needComplementForInitialNormal } = createLessonSlotBtn.dataset;
    const { needComplementForInitialSpecial } = createLessonSlotBtn.dataset;
    const { needComplementForFirstNormal } = createLessonSlotBtn.dataset;
    const { needComplementForFirstSpecial } = createLessonSlotBtn.dataset;
    const { needComplementForSecondClassInitial } = createLessonSlotBtn.dataset;
    const { needComplementForSecondClass } = createLessonSlotBtn.dataset;
    // 新規作成か編集か
    const { newRecord } = createLessonSlotBtn.dataset;

    // 編集の時は実行しない。
    if (!newRecord) return;
    // 2段階の教習枠の場合、補正用受講履歴は作らない。
    if (stage !== 'first') return;

    let message;
    const attentions =
      '現在この教程を対面で受講済みと推定される下記教習生には「完了(対面)」もしくは「免除」の受講判定を自動で付与しますがよろしいですか？作成された受講履歴は削除できません。';
    const firstAfterEntry = '「第1段階受講中」かつ「入校中」「卒業済」「退校済み」(*)';
    const secondAfterEntry = '「第2段階受講中」かつ「入校中」「卒業済」「退校済み」(*)';
    const allSkippers = '全ての通常学科免除者';
    const secondBeforeEntrySkippers = '「第2段階受講中」かつ「入校前」の通常学科免除者';
    const annotation = '*「入校前」の教習生は未受講とみなすため対象外です。';

    if (category === 'first_class') {
      // [一種] 条件分岐概要
      // 1-1枠かそれ以外の1段階教程か => 通常学科か非免除学科か => 対象の教習生が存在しているか
      if (course === '1') {
        if (kind === 'first_normal' && needComplementForInitialNormal === 'true') {
          message = `第1段階1教程（通常）の枠を作成する場合、${attentions}\n\n- ${secondAfterEntry}\n- ${firstAfterEntry}\n- ${allSkippers}\n\n${annotation}`;
        } else if (needComplementForInitialSpecial === 'true') {
          message = `第1段階1教程（非免除）の枠を作成する場合、${attentions}\n\n- ${secondAfterEntry}\n- ${firstAfterEntry}\n- ${secondBeforeEntrySkippers}\n\n${annotation}`;
        }
      } else if (kind === 'first_normal' && needComplementForFirstNormal === 'true') {
        message = `第1段階（通常）の枠を作成する場合、${attentions}\n\n- ${secondAfterEntry}\n- ${allSkippers}\n\n${annotation}`;
      } else if (needComplementForFirstSpecial === 'true') {
        message = `第1段階（非免除）の枠を作成する場合、${attentions}\n\n- ${secondAfterEntry}\n- ${secondBeforeEntrySkippers}\n\n${annotation}`;
      }
    } else if (course === '1' && needComplementForSecondClassInitial === 'true') {
      // [二種]条件分岐概要
      // 1-1枠かそれ以外の1段階教程か => 対象の教習生が存在しているか
      message = `第1段階1教程の枠を作成する場合、${attentions}\n\n- ${secondAfterEntry}\n- ${firstAfterEntry}\n\n${annotation}`;
    } else if (needComplementForSecondClass === 'true') {
      message = `第1段階の枠を作成する場合、${attentions}\n\n- ${secondAfterEntry}\n\n${annotation}`;
    }
    if (message) {
      window.confirm(message) ? true : e.preventDefault();
    }
  });
};
